import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import LogisticsTreasuryMobile from "../mobile/logistics/LogisticsTreasuryMobile";
import LogisticsTreasury from "./pages/LogisticsTreasury";

export default function ResponsiveLogisticsTreasury(props) {
  return useIsMobile() ? <LogisticsTreasuryMobile {...props} /> : <LogisticsTreasury {...props} />;
}
